/**
 * Contenido de los tres planes de precios.
 *
 * Cada idioma define su propia versión del mismo contenido: el nombre y el
 * precio son iguales en todos, mientras que la descripción, las ventajas, la
 * nota al pie y el texto del botón van traducidos. Lo que no cambia con el
 * idioma —el color de cada plan y cuál va destacado— vive en el componente que
 * los muestra.
 */
// Lo que no cambia con el idioma: el color de cada plan y cuál va destacado.
export const planStyles = [
  { color: '#0095fc', highlight: false },
  { color: '#7800f7', highlight: true },
  { color: '#0ff0b3', highlight: false },
];

export const pricingPlans = {
  ES: {
    plans: [
      {
        name: 'START',
        tag: 'VENDE',
        price: '34 €',
        period: '/mes',
        blurb: 'Para empezar a vender con TPV en la nube, sin complicaciones.',
        features: [
          'Software TPV HIOPOS',
          'Gestión de ventas y caja',
          'Gestión de productos y tarifas',
          'Clientes',
          'Informes esenciales',
          'Copias de seguridad',
          'Actualizaciones',
          'Soporte técnico estándar',
        ],
        note: 'Ideal para: pequeños comercios, cafeterías, panaderías, peluquerías y negocios con una operativa sencilla.',
        cta: 'Elegir START',
      },
      {
        name: 'PRO',
        tag: 'GESTIONA',
        badge: 'MÁS ELEGIDO',
        price: '49 €',
        period: '/mes',
        blurb: 'Para gestionar el día a día y crecer con los datos en la mano.',
        features: [
          'Todo START',
          'Software adicional según sector',
          'Gestión avanzada',
          'Estadísticas ampliadas',
          'Herramientas digitales para clientes',
          'Servicios adicionales SmartPOS',
          'Soporte técnico prioritario',
          'SLA mejorado',
        ],
        note: 'El ecosistema HIOPOS dispone de soluciones para comandas, cocina, stock, reservas, pedidos online y analítica, entre otras.',
        cta: 'Quiero PRO',
      },
      {
        name: 'ELITE',
        tag: 'ESCALA',
        price: '69 €',
        period: '/mes',
        blurb: 'Para operativas exigentes y negocios con varios puntos de venta.',
        features: [
          'Todo PRO',
          'Software y módulos avanzados seleccionados',
          'Gestión avanzada del negocio',
          'Integraciones seleccionadas',
          'Servicios SmartPOS Premium',
          'Atención técnica prioritaria',
          'SLA Premium',
        ],
        note: 'HIOPOS contempla soluciones escalables, gestión de varios puntos de venta y herramientas ERP dentro de su ecosistema.',
        cta: 'Elegir ELITE',
      },
    ],
  },
  CA: {
    plans: [
      {
        name: 'START',
        tag: 'VEN',
        price: '34 €',
        period: '/mes',
        blurb: 'Per començar a vendre amb TPV al núvol, sense complicacions.',
        features: [
          'Programari TPV HIOPOS',
          'Gestió de vendes i caixa',
          'Gestió de productes i tarifes',
          'Clients',
          'Informes essencials',
          'Còpies de seguretat',
          'Actualitzacions',
          'Suport tècnic estàndard',
        ],
        note: 'Ideal per a: petits comerços, cafeteries, fleques, perruqueries i negocis amb una operativa senzilla.',
        cta: 'Triar START',
      },
      {
        name: 'PRO',
        tag: 'GESTIONA',
        badge: 'MÉS TRIAT',
        price: '49 €',
        period: '/mes',
        blurb: 'Per gestionar el dia a dia i créixer amb les dades a mà.',
        features: [
          'Tot START',
          'Programari addicional segons sector',
          'Gestió avançada',
          'Estadístiques ampliades',
          'Eines digitals per a clients',
          'Serveis addicionals SmartPOS',
          'Suport tècnic prioritari',
          'SLA millorat',
        ],
        note: "L'ecosistema HIOPOS disposa de solucions per a comandes, cuina, estoc, reserves, comandes en línia i analítica, entre d'altres.",
        cta: 'Vull PRO',
      },
      {
        name: 'ELITE',
        tag: 'ESCALA',
        price: '69 €',
        period: '/mes',
        blurb: 'Per a operatives exigents i negocis amb diversos punts de venda.',
        features: [
          'Tot PRO',
          'Programari i mòduls avançats seleccionats',
          'Gestió avançada del negoci',
          'Integracions seleccionades',
          'Serveis SmartPOS Premium',
          'Atenció tècnica prioritària',
          'SLA Premium',
        ],
        note: 'HIOPOS contempla solucions escalables, gestió de diversos punts de venda i eines ERP dins del seu ecosistema.',
        cta: 'Triar ELITE',
      },
    ],
  },
  EN: {
    plans: [
      {
        name: 'START',
        tag: 'SELL',
        price: '€34',
        period: '/mo',
        blurb: 'Start selling with a cloud POS, no complications.',
        features: [
          'HIOPOS POS software',
          'Sales and cash management',
          'Product and price management',
          'Customers',
          'Essential reports',
          'Backups',
          'Updates',
          'Standard technical support',
        ],
        note: 'Ideal for: small shops, cafés, bakeries, salons and businesses with simple operations.',
        cta: 'Choose START',
      },
      {
        name: 'PRO',
        tag: 'MANAGE',
        badge: 'MOST CHOSEN',
        price: '€49',
        period: '/mo',
        blurb: 'Run the day to day and grow with the numbers in your hand.',
        features: [
          'Everything in START',
          'Extra software by sector',
          'Advanced management',
          'Extended statistics',
          'Digital tools for customers',
          'Additional SmartPOS services',
          'Priority technical support',
          'Improved SLA',
        ],
        note: 'The HIOPOS ecosystem includes solutions for kitchen orders, stock, bookings, online orders and analytics, among others.',
        cta: 'I want PRO',
      },
      {
        name: 'ELITE',
        tag: 'SCALE',
        price: '€69',
        period: '/mo',
        blurb: 'For demanding operations and businesses with several locations.',
        features: [
          'Everything in PRO',
          'Selected advanced software and modules',
          'Advanced business management',
          'Selected integrations',
          'SmartPOS Premium services',
          'Priority technical assistance',
          'Premium SLA',
        ],
        note: 'HIOPOS includes scalable solutions, multi-location management and ERP tools within its ecosystem.',
        cta: 'Choose ELITE',
      },
    ],
  },
  FR: {
    plans: [
      {
        name: 'START',
        tag: 'VENDRE',
        price: '34 €',
        period: '/mois',
        blurb: 'Pour commencer à vendre avec un TPV cloud, sans complications.',
        features: [
          'Logiciel TPV HIOPOS',
          'Gestion des ventes et de la caisse',
          'Gestion des produits et des tarifs',
          'Clients',
          'Rapports essentiels',
          'Sauvegardes',
          'Mises à jour',
          'Support technique standard',
        ],
        note: 'Idéal pour : petits commerces, cafés, boulangeries, salons de coiffure et activités simples.',
        cta: 'Choisir START',
      },
      {
        name: 'PRO',
        tag: 'GÉRER',
        badge: 'LE PLUS CHOISI',
        price: '49 €',
        period: '/mois',
        blurb: 'Pour gérer le quotidien et grandir avec les chiffres en main.',
        features: [
          'Tout START',
          'Logiciels supplémentaires selon le secteur',
          'Gestion avancée',
          'Statistiques étendues',
          'Outils numériques pour les clients',
          'Services SmartPOS supplémentaires',
          'Support technique prioritaire',
          'SLA amélioré',
        ],
        note: "L'écosystème HIOPOS propose des solutions pour les commandes, la cuisine, le stock, les réservations, les commandes en ligne et l'analytique, entre autres.",
        cta: 'Je veux PRO',
      },
      {
        name: 'ELITE',
        tag: 'ÉVOLUER',
        price: '69 €',
        period: '/mois',
        blurb: 'Pour des opérations exigeantes et plusieurs points de vente.',
        features: [
          'Tout PRO',
          'Logiciels et modules avancés sélectionnés',
          "Gestion avancée de l'entreprise",
          'Intégrations sélectionnées',
          'Services SmartPOS Premium',
          'Assistance technique prioritaire',
          'SLA Premium',
        ],
        note: "HIOPOS propose des solutions évolutives, la gestion de plusieurs points de vente et des outils ERP au sein de son écosystème.",
        cta: 'Choisir ELITE',
      },
    ],
  },
};